export const allowOnlyNumbers = (event) => {
  const charCode = event.charCode ? event.charCode : event.keyCode;

  // Allow numbers (0-9), decimal point (.), and prevent multiple decimal points
  if (
    (charCode < 48 || charCode > 57) && // Numbers 0-9
    charCode !== 46 // Decimal point
  ) {
    event.preventDefault();
  }

  // Prevent multiple decimal points
  if (charCode === 46 && event.target.value.includes('.')) {
    event.preventDefault();
  }
};

export const allowOnlyInteger = (event) => {
  const charCode = event.which ? event.which : event.keyCode;
  if (charCode < 48 || charCode > 57) {
    event.preventDefault();
  }
}


export const changeFormate = (date) => {
  if (!date) return ""; 
  const contractRenewalDate = new Date(date);

  if (isNaN(contractRenewalDate.getTime())) {
    return ""; 
  }

  const year = contractRenewalDate.getFullYear();
  const month = String(contractRenewalDate.getMonth() + 1).padStart(2, "0");
  const day = String(contractRenewalDate.getDate()).padStart(2, "0");
  const hours = String(contractRenewalDate.getHours()).padStart(2, "0");
  const minutes = String(contractRenewalDate.getMinutes()).padStart(2, "0");
  const seconds = String(contractRenewalDate.getSeconds()).padStart(2, "0");

  // Format date to "YYYY-MM-DDTHH:MM:SS" in local timezone
  const formattedDate = `${year}-${month}-${day}T${hours}:${minutes}:${seconds}`;
  return formattedDate;
};

export const SALES_DASHBOARD_REPRESENTATIVE = 'Dashboard Sales Representative';
export const SALES_DASHBOARD_ROLE = 'sales_representative';

export const canAccessSalesDashboard = (user) => {
  const hasRole = user?.roles?.includes(SALES_DASHBOARD_ROLE) ?? false;
  const hasPermission = user?.permissions?.includes(SALES_DASHBOARD_REPRESENTATIVE) ?? false;
  return hasRole && hasPermission;
};

/** API query param format for date-only fields (YYYY-MM-DD). */
export const toApiDateOnly = (date) => {
  if (!date) return '';
  const d = new Date(date);
  if (isNaN(d.getTime())) return '';
  const year = d.getFullYear();
  const month = String(d.getMonth() + 1).padStart(2, '0');
  const day = String(d.getDate()).padStart(2, '0');
  return `${year}-${month}-${day}`;
};
